import { Component, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'rl-delete-dialog-window',
  templateUrl: './delete-dialog-window.component.html',
  styleUrls: ['./delete-dialog-window.component.scss']
})
export class DeleteDialogWindowComponent{

  title : string;
  message : string;

  constructor() { }

  confirm = () : void => {};
  cancel = () : void => {};
}
